import React from "react";
import { Button, Dialog, DialogTitle, DialogContent, Card, CardMedia, Box, Typography } from "@mui/material";

const EXAMPLE_ENTRIES = [
  { name: "Titanic", image: "https://image.tmdb.org/t/p/w500/9xjZS2rlVxm8SFx8kPC3aIGCOYQ.jpg" },
  { name: "Leonardo DiCaprio", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/ts9l18VkDSooRGDWIeQegNVHciC.jpg" },
  { name: "Inception", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/ljsZTbVsrQSqZgWeep2B1QiDKuh.jpg" },
  { name: "Joseph Gordon-Levitt", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/fm2vDPCzT2185e8qIt8RLvDx44U.jpg" },
  { name: "500 Days of Summer", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/qXAuQ9hF30sQRsXf40OfRVl0MJZ.jpg" },
  { name: "Zooey Deschanel", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/30KQyjsXfrdm4Dcori7bDFTg9Le.jpg" },
  { name: "Elf", image: "https://media.themoviedb.org/t/p/w600_and_h900_bestv2/oOleziEempUPu96jkGs0Pj6tKxj.jpg" },
];

export function HowToPlayDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontFamily: "'Montserrat'", textAlign: "center" }}>
        How to Play
      </DialogTitle>
      <DialogContent sx={{ fontFamily: "'Montserrat'", fontSize: "14px" }}>
        <p>
          Create a <em>reel</em> to connect the <strong>start movie</strong> to the{" "}
          <strong>end movie</strong> by linking actors and movies.
        </p>
        <p>Example reel from <em>Titanic</em> to <em>Elf</em>:</p>

        <div
          style={{
            overflowX: "auto",
            scrollBehavior: "smooth",
            whiteSpace: "nowrap",
            padding: "10px 0",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              minWidth: "max-content",
            }}
          >
            {EXAMPLE_ENTRIES.map((entry, index, arr) => (
              <React.Fragment key={index}>
                <Card
                  sx={{
                    width: 80,
                    height: 140,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={entry.image}
                    alt={entry.name}
                    sx={{ height: 100, width: "100%", objectFit: "cover" }}
                  />
                  <Box sx={{ padding: "4px", textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "10px", fontFamily: "'Montserrat'", lineHeight: 1.2, whiteSpace: "normal" }}
                    >
                      {entry.name}
                    </Typography>
                  </Box>
                </Card>
                {index < arr.length - 1 && (
                  <Typography variant="h5" sx={{ margin: "0 6px", display: "inline-block", alignSelf: "center" }}>
                    →
                  </Typography>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        <p>
          You write the script! Build your reel in the fewest frames... or challenge yourself
          (e.g. choose no stars, all thrillers, only actresses).
        </p>

        <Button variant="contained" fullWidth onClick={onClose} sx={{ mt: 2 }}>
          Got it!
        </Button>
      </DialogContent>
    </Dialog>
  );
}
